import React, { Component } from 'react';
import './Scenario1.css';
import Scenario1TwoImg from '../../img/Scenario1Two.jpg';
import Scenario1Three from './Scenario1Three';



class Scenario1Two extends Component {
    constructor(props) {
        super(props);
        this.state = {
            disabled: true,
            show: false
        };
        this.howItWorks = React.createRef()
    }

    handleClick() {
        this.setState({
            disabled: false
        })
    }

    toggleDiv = () => {
        const { show } = this.state;
        this.setState({
            show: true
        })
    }

    scrollTohowItWorks = () => window.scroll({
        top: this.howItWorks.current.offsetTop,
        left: 0,
        behavior: 'smooth'
    });

    render() {
        return (
            <div className='Scenario1TwoWrap' >
                <div className='Scenario1TwoWraper'>
                    <img src={Scenario1TwoImg} alt='Сценарий 1' />
                    <div className='Scenario1TwoRightBlock'>
                        <div className='Scenario1TwoRightTitle'>Сіздің ойыңызша осы жағдайда инспектор қандай құқықты белден басып отыр?</div>
                        <div className='ScenarioAllAnons'>Бірнеше дұрыс жауаптар мүмкін</div>
                        <div className='Scenario1TwoRightCheckWrap'>
                            <label className="Scenario1TwoRightCheck" >Тұрғылықты халықтың құқтарын<input type="checkbox" onChange={() => this.handleClick()} /><span className="checkmark"></span></label>
                            <label className="Scenario1TwoRightCheck" >Соттың істі әділ қарау құқығын<input type="checkbox" onChange={() => this.handleClick()} /><span className="checkmark"></span></label>
                            <label className="Scenario1TwoRightCheck" >Өмір сүру құқығын<input type="checkbox" onChange={() => this.handleClick()} /><span className="checkmark"></span></label>
                            <label className="Scenario1TwoRightCheck" >Бостандық пен жеке өмірге қол сұқпау құқығын<input type="checkbox" onChange={() => this.handleClick()} /><span className="checkmark"></span></label>
                            <label className="Scenario1TwoRightCheck" >Жәбірлеуден қорғау құқығын<input type="checkbox" onChange={() => this.handleClick()} /><span className="checkmark"></span></label>
                            <label className="Scenario1TwoRightCheck" >Жеке өміріне, тұрағына немесе хат алмасуына еркінен тыс араласу құқығын<input type="checkbox" onChange={() => this.handleClick()} /><span className="checkmark"></span></label>
                            <label className="Scenario1TwoRightCheck" >Тұтқын құқығын<input type="checkbox" onChange={() => this.handleClick()} /><span className="checkmark"></span></label>
                        </div>
                    </div>
                </div>
                <button disabled={this.state.disabled} onClick={this.toggleDiv} ><div onClick={() => this.scrollTohowItWorks()}>Дұрыс жауабын қараңыз</div></button>
                <div className="contentAppear" ref={this.howItWorks}>{this.state.show && <Scenario1Three />}</div>
            </div>
        );
    }
}

export default Scenario1Two;